import { render, staticRenderFns } from "./NutritionTable.vue?vue&type=template&id=631e328b&"
import script from "./NutritionTable.vue?vue&type=script&lang=ts&"
export * from "./NutritionTable.vue?vue&type=script&lang=ts&"
import style0 from "./NutritionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports